import { collectLegacyLiabilities, mapLegacyLoan } from "../Interview/legacyLiabilitiesView"

const emptyIncome = {
    base: "",
    overtime: "",
    bonuses: "",
    commissions: "",
    military: "",
    other: "",
}

const emptyOccupation = {
    selfemployed: false,
    employername: "",
    incomeorloss: "",
    incomeorlossperiod: "monthly",
    percentownership: "",
    income: emptyIncome,
}

const mapOwnedProperties = (properties, primaryPartyId = "") =>
    (properties || []).map((item) => ({
        occupancy: item.occupancy || "",
        insurancemaintenancetaxes: item.insuranceMaintenanceTaxes || item.insurancemaintenancetaxes || "",
        loans: (item.loans || []).map((loan) => mapLegacyLoan(loan, primaryPartyId)),
    }))

const toLegacyPerson = (person, application) => {
    if (!person) {
        return {
            firstname: "",
            lastname: "",
            occupation: emptyOccupation,
            otheroccupations: [],
            income: { otherincome: [] },
            ownedproperties: [],
            expenses: { currentrent: "" },
            presentaddressownership: "",
            presentaddressstreet: "",
            socialsecurity: "",
            finances: { alimony: [] },
        }
    }
    const reo = application?.finance?.realEstateByPartyId?.[person.partyId]?.properties || []
    const liabilities = application?.finance?.liabilitiesByPartyId?.[person.partyId] || {}
    const primaryPartyId = application?.primaryPartyId
        || (application?.participantOrder || [])[0]
        || ""
    return {
        firstname: person.firstName || "",
        lastname: person.lastName || "",
        occupation: { ...emptyOccupation, ...(person.occupation || {}), income: { ...emptyIncome, ...(person.occupation?.income || {}) } },
        otheroccupations: person.otheroccupations || [],
        income: person.income || { otherincome: [] },
        ownedproperties: mapOwnedProperties(reo, primaryPartyId),
        expenses: { currentrent: person.monthlyRent || "" },
        presentaddressownership: person.residenceOwnership || "",
        presentaddressstreet: person.presentAddress?.street || "",
        socialsecurity: person.socialSecurity || "",
        finances: { alimony: person.income?.alimony || liabilities.additionalExpenses || [] },
    }
}

export const personDisplayNameV2 = (person) =>
    `${person?.firstName || ""} ${person?.lastName || ""}`.trim()

export const adaptV2ApplicationForIncomeCalc = (application, activePartyId) => {
    const byId = application?.participantsById || {}
    const order = application?.participantOrder?.length
        ? application.participantOrder
        : Object.keys(byId)
    const active = byId[activePartyId] || byId[application?.primaryPartyId] || null
    const otherId = order.find((id) => id && id !== active?.partyId)
    const other = otherId ? byId[otherId] : null
    const borrower = toLegacyPerson(active, application)
    const coborrower = toLegacyPerson(other, application)
    const legacyLiabilities = collectLegacyLiabilities(application)
    return {
        borrower,
        coborrower,
        hascoborrower: other ? "withcoborrower" : "",
        property: application?.property || {},
        selection: {
            ...(application?.selection || {}),
            selectedloan: application?.selection?.selectedloan || { monthly_payment: 0 },
        },
        assetsandliabilities: {
            loans: legacyLiabilities.loans,
            newloans: legacyLiabilities.newloans,
        },
    }
}
